
import { CanMatchFn, Route, UrlSegment, Router } from '@angular/router';
import { inject } from '@angular/core';

export const urlValidatorGuard: CanMatchFn = (
    route: Route,
    segments: UrlSegment[]
) => {
    const router = inject(Router);

    const fullPath = '/' + segments.map(s => decodeURIComponent(s.path)).join('/');

        const validPatterns = [
                // صفحه اصلی
                /^\/$/,
                /^\/fa(?:\/.*)?$/,

                // صفحات ثابت
                /^\/international-hotels\/?$/,
                // iran-hotels
                /^\/iran-hotels\/?$/,
                /^\/persian\/(policy|privacypolicy|best-price-guarantee)\/?$/,
                /^\/help\/?$/,
                /^\/downloads-app\/?$/,
                // deals
                /^\/deals\/[^/]+\/?$/,
                /^\/help(?:\/[a-zA-Z0-9_-]+)?\/?$/,
                // residency
                /^\/residency\/?$/,
                /^\/residency\/group\/[^/]+\/?$/,

                // reviews
                /^\/reviews\/?$/,
                /^\/reviews\/[a-zA-Z0-9\u0600-\u06FF_-]+\/?$/,

                // hotels: city-hotels یا city-hotels/hotel
                /^\/[a-zA-Z0-9-%آ-ی]+-hotels\/?$/,
                /^\/[a-zA-Z0-9-%آ-ی]+-hotels\/[\u0600-\u06FFa-zA-Z0-9%\-–—ـ_\s]+\/?$/,

                // ecolodge
                /^\/ecolodge\/?$/,
                /^\/ecolodge\/[^/]+\/?$/,
                /^\/ecolodge\/[^/]+\/map\/?$/,
                /^\/ecolodge\/[\u0600-\u06FFa-zA-Z0-9%\-–—ـ_]+\/[\u0600-\u06FFa-zA-Z0-9%\-–—ـ_]+\/?$/,
                /^\/ecolodge\/[^/]+\/[^/]+\/نظرات\/?$/,

                // city routes
                /^\/[a-zA-Z0-9-%آ-ی]+\/map\/?$/,
                /^\/[a-zA-Z0-9-%آ-ی]+\/(star\d+|[a-zA-Z0-9-]+-rec)\/?$/,
                /^\/[a-zA-Z0-9-%آ-ی]+\/[^/]+\/?$/,
                /^\/[a-zA-Z0-9-%آ-ی]+\/[^/]+\/نظرات\/?$/,

                // country codes (3 letters)
                /^\/[a-zA-Z]{3}\/?$/,
                /^\/[a-zA-Z0-9آ-ی%]{3}\/[^/]+\/?$/,
                /^\/[a-zA-Z0-9آ-ی%]{3}\/[^/]+\/[^/]+\/?(?:\?.*)?$/,

                // resident
                /^\/[a-zA-Z0-9-%آ-ی]+\/[^/]+\/resident\/?$/,
        ];




    const isValid = validPatterns.some(p => p.test(fullPath));
    if (!isValid) {
        router.navigateByUrl('/notfound');
        return false;
    }

    return true;
};
